import { useEffect } from "react";

/**
 * Hides the prestitial ad overlay (`#MyPageOverlay`) on mount. Use on
 * pages that don't render through BHBasePage (which handles this itself).
 *
 * Named to avoid the collision with `@sphtech/sph-web-ui`'s
 * `useRemoveOverlay`, which strips modal/scroll-lock body classes on
 * navigation — entirely different behaviour despite the similar name.
 */
export default function useHidePrestitialOverlay() {
  useEffect(() => {
    if (typeof document !== "undefined") {
      const overlay = document.getElementById("MyPageOverlay");
      if (overlay != null) {
        overlay.style.display = "none";
      }
    }
  }, []);
}
